module.exports = __webpack_public_path__ + "img/puzzle.cfb56931.png";